import { Component, EventEmitter, OnInit, Output, Input } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';
import { BaseService, SettingsService, StorageService } from 'src/app/core/services';
import { ConfigurationService } from 'src/app/core/services/configuration.service';
import { PlanService } from 'src/app/core/services/plan.service';
import { SessionService } from 'src/app/core/services/session.service';
import { SubscriptionService } from 'src/app/core/services/subscription.service';
import { COUPON } from '../../constants';
import { R_ACCOUNT_SETTINGS } from 'src/app/shared/constants/route.constants';
import { environment } from 'src/environment';
import { NgClass, NgIf } from '@angular/common';
import { SignupStepComponent } from '../signup-step/signup-step.component';
import { StripeInfoComponent } from '../stripe-info/stripe-info.component';
import { PlanInfoComponent } from '../plan-info/plan-info.component';
import { InhouseAnalyticsService } from 'src/app/core/services/inhouse-analytics.service';

@Component({
  selector: 'app-payment-method-type',
  templateUrl: './payment-method-type.component.html',
  styleUrls: ['./payment-method-type.component.scss'],
  standalone: true,
  imports: [NgIf, NgClass, SignupStepComponent, StripeInfoComponent, PlanInfoComponent]
})
export class PaymentMethodTypeComponent implements OnInit {
  paymentMethodLength: any;
  queryParams;
  backRoute = 'auth/plan';
  currentStep = 3;
  cardAvail = false;
  idealAvail = false;
  routerNav = { card: '/auth/payment', ideal: '/auth/ideal' };
  discountCoupon: any;
  discountType: any;
  livePage: any;
  @Input() auth_head: any;
  @Output() emitCardMethod = new EventEmitter<{ session_id: string, payment_type: string, paymentMethodLength: number }>();
  @Input() coupon_valid;
  @Input() step;
  @Input() page;
  @Input() type;
  @Output() emitStep = new EventEmitter<Number>();
  previous = true;
  skinName = environment.skinName;
  paymentGateway: any;
  constructor(public settingsService: SettingsService, private baseService: BaseService, public planService: PlanService,
    public configService: ConfigurationService, public subscriptionService: SubscriptionService,
    private route: ActivatedRoute, private sessionService: SessionService,
    private storageService: StorageService, private router: Router, private analyticsService: InhouseAnalyticsService) {
  }

  ngOnInit(): void {
    this.paymentGateway = this.settingsService.paymentGateway;
    this.queryParams = this.route.snapshot.queryParams;
    this.livePage = this.router.url.match('/live/');
    const homePage = this.router.url.match('/home');
    const pageWiseFlow = this.router.url.match('/voucher/method') || this.router.url.match('/auth/stripe') || this.queryParams['session_id'];
    if(pageWiseFlow) this.previous = false;
    const contentDetailPage = this.router.url.match('/v/')|| this.router.url.match('/video/') || this.router.url.match('/series/') || this.router.url.match('/vs/');
    if (this.livePage?.length || homePage?.length || contentDetailPage?.length || (this.router.url === R_ACCOUNT_SETTINGS && this.type !== 'redeemCoupon')) this.currentStep = 2;
    else this.currentStep = 3;
    if (this.queryParams['session_id']) {
      this.subscriptionService.paymentSessionId = this.queryParams['session_id'];
    }
    this.discountCoupon = this.storageService.getLocalStore('discount_code');
    this.discountType = this.storageService.getLocalStore('discount_type');
    if ((this.discountCoupon && this.discountType && this.router.routerState.snapshot.url === '/account/settings') || this.router.routerState.snapshot.url === '/account/settings') this.backRoute = '/account/settings';
    if (this.discountCoupon && this.discountType && !(this.router.routerState.snapshot.url === '/account/settings')) this.backRoute = 'voucher/plan'
    const prevPaymentPathName = location.href;
    this.storageService.setLocalStore('prevPaymentPathName', prevPaymentPathName);
    if(this.planService.plansLength>0)this.validateSession(this.subscriptionService.paymentSessionId);
    if(this.page === 'account' || this.page === 'live') this.currentStep = this.step;
  }

  authOrVoucher() {
    this.subscriptionService.userPlan().subscribe((data) => {
      const subscriptions = data.plans;
      const selectedPlan = subscriptions.find(plan => plan.coupon_mapped === 1);
      const couponMapped = this.coupon_valid || selectedPlan?.coupon_mapped || 0;
      if (this.discountType === COUPON && this.discountCoupon) {
        this.routerNav = { card: `/voucher/payment/card/${couponMapped}`, ideal: `/voucher/payment/ideal/${couponMapped}` };
      } else {
        const keyQueryParamTV = this.route.snapshot.queryParams['app'];
        if (keyQueryParamTV === this.baseService.keyQueryParamTV) {
          this.queryParams['app'] = this.baseService.keyQueryParamTV;
        } else if (keyQueryParamTV === this.baseService.keyQueryParamAppleTV) {
          this.queryParams['app'] = this.baseService.keyQueryParamAppleTV;
        }
      }
      if (this.cardAvail === true && this.idealAvail === false) {
        this.redirectToPaymentPage(this.routerNav.card, 'card');
      } else if (this.cardAvail === false && this.idealAvail === true) {
        this.redirectToPaymentPage(this.routerNav.ideal, 'ideal');
      }
      this.baseService.loaderSource.next(false);
    })

  }

  validateSession(sessionId) {
    this.sessionService.validateSession(sessionId).subscribe((resp) => {
      const errRoute = (this.discountType === COUPON && this.discountCoupon) ?
        this.baseService.voucherPayErrorRoute : this.baseService.authPayErrorRoute;
      if (resp.status_code === 200) {
        const data = resp.data;
        data.stripe_payment_methods.forEach(element => {
          if (element === 'card') this.cardAvail = true;
          if (element === 'ideal') this.idealAvail = true;
        });
        this.paymentMethodLength = data.stripe_payment_methods.length;
        const errorFound = (data.already_subscribed || data.expired || data.invalid);
        const errorResult = {
          already_subscribed: data.already_subscribed, expired: data.expired, invalid: data.invalid
        };
        if (errorFound) {
          this.baseService.loaderSource.next(false);
          this.baseService.navErrPage(errorResult, errRoute);
        } else {
          this.authOrVoucher();
        }
      } else {
        const errorResult = {
          already_subscribed: false, expired: false, invalid: true
        };
        this.baseService.navErrPage(errorResult, errRoute);
        this.baseService.loaderSource.next(false);
      }
    })
  }

  redirectToPaymentPage(url, type) {
    const selectedPlan = this.storageService.getSessionStore('selectedPlanData');
    const userType = this.storageService.getLocalStore('user_type');
    const eventObj = {
      event_type: 'event',
      event_name: 'Payment Method Selected',
      event_status: 'Success',
      discount_code: this.discountCoupon || '',
      value: selectedPlan.amount,
      payment_type: this.paymentGateway,
      subscription_status: userType,
      paid_user: userType,
      subscription_plan: selectedPlan.title,
      extra_info: type
    };
    this.analyticsService.trackUserActions(eventObj);

    if (this.router.url == R_ACCOUNT_SETTINGS || this.livePage?.length > 0 || this.page === 'contentDetail') {
      this.emitCardMethod.emit({ session_id: this.subscriptionService.paymentSessionId, payment_type: type, paymentMethodLength: this.paymentMethodLength });
    } else {
      this.router.navigate([url], { queryParams: this.queryParams })
    }
  }

  getSignStep($event) {
    this.emitStep.emit($event);
  }

}
